import { useQuery } from '@tanstack/react-query';

import { callService } from '@api/remote-call';

export const useCampaignBanners = (type: string, position: string) => {
  const { data: campaignBanner } = useQuery(['bannerDetail'], () =>
    callService(
      {
        service: 'ContentsService',
        method: 'campaignsBanner',
        version: 'v3',
      },
      {
        position: position,
        type: type,
      }
    )
  );
  return {
    campaignBanner,
  };
};
